import React, { useEffect, useState } from 'react';
import { Layer, Circle, Text, Group } from 'react-konva';
import { pinColor, PinState } from '../constants';

interface PuckPinProps {
  x: number;
  y: number;
  pinRadius: number;
  pinPosition: number;
  pinState: PinState;
  handleOnPinSelect?: (position: number) => void;
  disabled: boolean;
}
const PuckPin = (props: PuckPinProps) => {
  const {
    x = 0,
    y = 0,
    pinRadius = 20,
    pinPosition = 1,
    pinState = PinState.FREE,
    handleOnPinSelect,
    disabled,
  } = props;

  const [_pinState, _setPinState] = useState<PinState>(pinState);

  useEffect(() => {
    _setPinState(pinState);
  }, [pinState]);
  const updatePinState = (state: PinState) => {
    if (_pinState !== PinState.OCCUPIED) {
      _setPinState(state);
    }
  };
  const handleMouseEnter = () => {
    updatePinState(PinState.HOVER);
  };

  const handleMouseLeave = () => {
    _setPinState(pinState);
  };

  return (
    <Layer
      id="puckpin-layer"
      x={x + pinRadius}
      y={y + pinRadius}
      width={pinRadius * 2}
      height={pinRadius * 2}
      onMouseEnter={disabled ? null : handleMouseEnter}
      onMouseLeave={disabled ? null : handleMouseLeave}
      onClick={
        disabled || pinState === PinState.OCCUPIED
          ? null
          : () => {
              handleOnPinSelect(pinPosition);
            }
      }
    >
      <Group id="puckpin-layer-group">
        <Circle
          id="puckpin-layer-circle"
          radius={pinRadius - 1}
          fill={pinColor[_pinState].background}
          stroke={pinColor[_pinState].border}
          strokeWidth={2}
        />
        <Text
          id="puckpin-layer-text"
          x={-pinRadius}
          y={-pinRadius}
          text={`${pinPosition}`}
          fontSize={pinRadius}
          fontFamily="Calibri"
          width={pinRadius * 2}
          height={pinRadius * 2}
          align="center"
          verticalAlign="middle"
          fill={pinColor[_pinState].text}
        />
      </Group>
    </Layer>
  );
};

export default PuckPin;
